import { render, staticRenderFns } from "./SelectStandard.vue?vue&type=template&id=67182c64&scoped=true&"
import script from "./SelectStandard.vue?vue&type=script&lang=js&"
export * from "./SelectStandard.vue?vue&type=script&lang=js&"
import style0 from "./SelectStandard.vue?vue&type=style&index=0&id=67182c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67182c64",
  null
  
)

export default component.exports